const accessControlMessage = {
  'accessControlPage.roleFilterSelectBox.option.allAdmin': '企業管理者/管理者',
  'accessControlPage.roleFilterSelectBox.option.companyAdmin': '企業管理者',
  'accessControlPage.roleFilterSelectBox.option.admin': '管理者',
  'accessControlPage.subscriptionsTable.title.name': '名前',
  'accessControlPage.subscriptionsTable.title.role': '権限',
  'accessControlPage.ipAddress.validationError':
    'IPアドレスの形式で入力してください',
};

export default accessControlMessage;
